import React from 'react';
import { Link } from 'react-router-dom';
import useCurrentSessionToken from '../../hooks/useCurrentSessionToken';

const CurrentAuthDetails = (props) => {
	const currentToken = useCurrentSessionToken();
	return (
		<div>
			<p>Welcome to Current Auth Details Page</p>
			{!currentToken && <p>No token provided</p>}
			{currentToken && <p>Provided token: {currentToken}</p>}
		</div>
	);
};

export default CurrentAuthDetails;
